'use client';

import './sider-right.scss';
import { useContentSize } from '@/components/SizeProvider';
import { getBodyFontSize } from '@/lib/utils/typography';
import { getSiderSize } from '@/lib/utils/desktopGeometry';
import {useEffect, useState} from 'react';
import {ProjectModel} from '@/lib/models/Project';
import {usePathname} from 'next/navigation';
import ListProject from './ListProject';
import {ROUTES} from '@/lib/routes';
import ContactInfo from './ContactInfo';

interface Props {
  projects: ProjectModel[];
}

const SiderRight = ({ projects }: Props) => {
  const { width: widthContent, height: heightContent } = useContentSize();
  const siderSize = getSiderSize(widthContent, heightContent);

  const pathname = usePathname();
  const [activeProjectId, setActiveProjectId] = useState(0);

  useEffect(() => {
    if (pathname?.includes(ROUTES.projectDetail)) {
      const slug = pathname.replace(`${ROUTES.projectDetail}/`, '');
      const projectActive = projects.find(item => item.slug === slug);
      if (projectActive) {
        setActiveProjectId(projectActive.id);
      }
    }
    // Don't highlight anything when we navigate to homepage
    else {
      setActiveProjectId(0);
    }
  }, [pathname, projects]);

  return (
    <div className='sider-right' style={{
      width: siderSize.width,
      fontSize: getBodyFontSize(widthContent, { ceil: false }),
      height: siderSize.height,
    }}>
      <ListProject activeProjectId={activeProjectId} projects={projects}/>
      <ContactInfo/>
    </div>
  )
};

export default SiderRight;
  